import '../TherapistSchedulePage/TherapistSchedulePage.css';
import {useAuth} from '../../contexts/AuthContext';
import {useQuery} from 'react-query';
import React, { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import ConsultationDetail, { Conversation, ConsultationCard, consultationStatuses } from '../../components/ConsultationDetail';
import './ConsultationList.css';
export function TherapistConsultationPage() {
  const {
    id
  } = useParams();
  return <ConsultationDetail id={id} role="specialist" back="/therapist/bookings" />;
}
export function TherapistQuestionPage() {
  const {
    id
  } = useParams();
  return <div className="consultation-detail"><Link className="consult-back" to="/therapist/bookings">← Консультации и сообщения</Link><h1>Вопросы клиента</h1><Conversation role="specialist" endpoint={`/api/agregator/specialist/threads/${id}/messages`} /></div>;
}
export default function TherapistBookingsPage() {
  const {user}=useAuth(),[params,setParams]=useSearchParams(),isAdmin=user?.role==='admin';
  const selected=isAdmin?(params.get('therapist') || ''):'',target=selected || user?.id;
  const {data:people=[],isLoading,error}=useQuery(['scheduleTherapists'],async()=>(await axios.get('/api/admin/therapists',{withCredentials:true})).data,{enabled:isAdmin});
  return <>{isAdmin && <section className="ts-panel ts-admin-picker"><label>Специалист<select aria-label="Специалист" value={selected} disabled={isLoading} onChange={e=>setParams(e.target.value?{therapist:e.target.value}:{})}><option value="">Мои консультации</option>{people.map(p=><option key={p.id} value={p.id}>{p.name} — {p.email}</option>)}</select></label>{error && <p role="alert">Не удалось загрузить специалистов.</p>}<Link to={'/therapist/schedule'+(selected?'?therapist='+selected:'')}>Расписание →</Link></section>}<OwnBookings key={target} target={target} admin={isAdmin} own={String(target)===String(user?.id)} isTherapist={user?.is_therapist}/></>;
}
function OwnBookings({target,admin,own,isTherapist}) {
  const [bookings, setBookings] = useState([]),
    [threads, setThreads] = useState([]),
    [error, setError] = useState(''),
    [notice, setNotice] = useState(''),
    [loading, setLoading] = useState(true),
    [status, setStatus] = useState(''),
    [from, setFrom] = useState(''),
    [to, setTo] = useState('');
  useEffect(() => {
    let live = true;
    const load = async () => {
      const [b, t] = await Promise.all([axios.get(admin?'/api/admin/consultation-bookings?therapist_id='+target:'/api/agregator/specialist/consultations', {
        withCredentials: true
      }), own && isTherapist ? axios.get('/api/agregator/specialist/threads', {
        withCredentials: true
      }) : Promise.resolve({data:[]})]);
      if (live) {
        setBookings(b.data);
        setThreads(t.data);
        setLoading(false);
      }
    };
    load().catch(e => {
      if (live) {
        setError(e.response?.data?.message || 'Не удалось загрузить консультации.');
        setLoading(false);
      }
    });
    if(own && isTherapist) axios.post('/api/agregator/specialist/payments/refresh', {}, {
      withCredentials: true,
      timeout: 120000
    }).then(load).catch(() => {
      if (live) setNotice('Проверка оплат не удалась. Повторите её на странице консультации.');
    });
    return () => {
      live = false;
    };
  }, [target,admin,own,isTherapist]);
  const filtered = bookings.filter(b => (!status || b.status === status) && (!from || b.booking_date >= from) && (!to || b.booking_date <= to));
  return <div className="specialist-consultations"><h1>Консультации</h1>{error && <p role="alert">{error}</p>}{notice && <p role="status">{notice}</p>}<div className="specialist-consult-filters"><div className="specialist-consult-filter-grid"><label>Статус<select value={status} onChange={e => setStatus(e.target.value)}><option value="">Все статусы</option>{Object.entries(consultationStatuses).map(([key, label]) => <option key={key} value={key}>{label}</option>)}</select></label><label>С даты<input type="date" value={from} onChange={e => setFrom(e.target.value)} /></label><label>По дату<input type="date" value={to} onChange={e => setTo(e.target.value)} /></label></div></div>{loading ? <p>Загрузка…</p> : filtered.map(b => <ConsultationCard key={b.id} booking={b} specialist to={admin && (!own || !isTherapist) ? `/admin/consultations/${b.id}` : `/therapist/bookings/${b.id}`} />)}{!loading && !filtered.length && <p>Консультаций по этим условиям нет.</p>}<h2>Вопросы клиентов</h2>{threads.length ? threads.map(t => <Link key={t.client_id} className="specialist-question-card" style={{
      display: 'block',
      textDecoration: 'none',
      color: 'inherit'
    }} to={`/therapist/messages/${t.client_id}`}><strong>{t.client_name}</strong><p style={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }}>{t.body}</p><span>Открыть переписку →</span></Link>) : <p>Новых переписок пока нет.</p>}</div>;
}
